import api from '../api';

export default {
  create(data) {
    return api.post(`/commerce/orders`, data);
  },

  update(order, data, signature) {
    return api.patch(`/commerce/orders/${order}`, data, { params: { signature } });
  },

  place(order, data, signature) {
    return api.post(`/commerce/orders/${order}/place`, data, { params: { signature } });
  },

  showPayment(payment, signature) {
    return api.get(`/commerce/payments/${payment}`, { signature });
  },

  cancelPayment(payment, signature) {
    return api.post(`/commerce/payments/${payment}/cancel`, {}, { params: { signature } });
  },
};
